export default __webpack_public_path__ + "static/media/Urine.09360cee.svg";